const canPlayCallback = (e: Event) => {
  const video = e.target as HTMLVideoElement;
  toggleLoader(video, false);
  if (video.dataset.isVisible == 'true') {
    video.play();
  }
};

const playOnHover = (e: Event) => {
  const video = e.target as HTMLVideoElement;
  playVideo(video);
};

const toggleLoader = (video: HTMLVideoElement, visible: boolean) => {
  const loader = video.nextElementSibling;
  if (!loader) {
    return;
  }
  (loader as HTMLElement).style.opacity = visible ? '100' : '0';
};

const playVideo = (video: HTMLVideoElement) => {
  toggleLoader(video, false);
  video.play();
};
const loadVideo = (video: HTMLVideoElement) => {
  if (video.readyState == HTMLMediaElement.HAVE_NOTHING) {
    toggleLoader(video, true);
    video.load();
  }
};

const pauseOnMouseOut = (e: Event) => {
  const video = e.target as HTMLVideoElement;
  toggleLoader(video, false);
  video.pause();
};

export const useVideoAutoplayObserver = (autoPlay: boolean): IntersectionObserver => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target as HTMLVideoElement;
        if (entry.isIntersecting) {
          video.dataset.isVisible = 'true';
          loadVideo(video);

          if (autoPlay) {
            video.addEventListener('canplay', canPlayCallback.bind(video));
          } else {
            video.addEventListener('mouseover', playOnHover);
            video.addEventListener('mouseout', pauseOnMouseOut);
          }
        } else {
          delete video.dataset.isVisible;
          video.removeEventListener('canplay', canPlayCallback);
          video.removeEventListener('mouseover', playOnHover);
          video.removeEventListener('mouseout', pauseOnMouseOut);
          video.pause();
        }
      });
    },
    { threshold: 0.8 },
  );
  return observer;
};
